import { render, staticRenderFns } from "./nice-file.vue?vue&type=template&id=0ce0b15b&scoped=true"
import script from "./nice-file.vue?vue&type=script&lang=js"
export * from "./nice-file.vue?vue&type=script&lang=js"
import style0 from "./nice-file.vue?vue&type=style&index=0&id=0ce0b15b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce0b15b",
  null
  
)

export default component.exports